import { render, staticRenderFns } from "./deliveries.vue?vue&type=template&id=65bf33ff"
import script from "./deliveries.js?vue&type=script&lang=js&external"
export * from "./deliveries.js?vue&type=script&lang=js&external"
import style0 from "./deliveries.scss?vue&type=style&index=0&prod&lang=scss&external"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports